import React, { FC } from 'react'

import { Typography } from '@smarty-nx/ds'
import { Link } from 'gatsby'

import { content } from './europe.content'
import PageHead from '../../../components/PageHead'
import {
  AltPara,
  BreadCrumbs,
  Card,
  Container,
  Desktop,
  Mobile,
  RoamingHeading,
  RoamingListItem,
  SiteContainer,
  SubHeading,
  TopFlag,
} from '../../../components/shared'
import classes from '../../../components/shared/roaming.module.scss'
import withApp from '../../../components/withApp/withApp'
import { PAGE_CONSTANTS } from '../../../constants/globalStrings'
import EuropeSVG from '../../../static/images/europe.svg'

const IRELAND_COUNTRY_CODE = 'IE'

interface EuropePageContext {
  display_country: string
  iso_country_code: string
}

interface EuropeProps {
  pageContext: EuropePageContext
  location: { pathname: string }
}

const Europe: FC<EuropeProps> = ({
  pageContext: { display_country, iso_country_code },
}) => {
  const isIreland = iso_country_code === IRELAND_COUNTRY_CODE

  return (
    <SiteContainer>
      <BreadCrumbs>
        <Desktop>
          <Link
            data-testid={PAGE_CONSTANTS.ROAMING.testId}
            to={PAGE_CONSTANTS.ROAMING.route}
          >
            {content.breadcrumbRoot}
          </Link>
          <Typography
            component="span"
            variant="Kollektif/Small"
            className={classes.navLink}
          >
            {'>'}
          </Typography>
          <Link
            data-testid={PAGE_CONSTANTS.ROAMING_EUROPE.testId}
            to={PAGE_CONSTANTS.ROAMING_EUROPE.route}
          >
            {content.breadcrumbCurrent}
          </Link>
          <Typography
            component="span"
            variant="Kollektif/Small"
            className={classes.navLink}
          >
            {'>'}
          </Typography>{' '}
          {display_country}
        </Desktop>
        <Mobile>
          {'< '}
          <Link to={PAGE_CONSTANTS.ROAMING_EUROPE.route}>
            {content.breadcrumbMobile}
          </Link>
        </Mobile>
      </BreadCrumbs>
      <TopFlag
        src={`/assets/images/flags/${iso_country_code.toLowerCase()}.png`}
        alt={iso_country_code}
      />
      <RoamingHeading>{content.heading(display_country)}</RoamingHeading>
      <Container
        style={{ marginBottom: '60px' }}
        bgColor="#ffd67c"
        padding="15px"
      >
        <div className={classes.innerPadding}>
          <img
            src={EuropeSVG}
            alt={content.imageAlt}
            loading="lazy"
            decoding="async"
          />
          <SubHeading>{content.goodNewsSubheading(display_country)}</SubHeading>
          <SubHeading>{content.anywhereSubheading}</SubHeading>
          <ul>
            <RoamingListItem>{content.callsAndTexts}</RoamingListItem>
            <RoamingListItem>
              {isIreland
                ? content.irelandDataAllowance
                : content.standardDataAllowance}
            </RoamingListItem>
            <RoamingListItem>{content.noHiddenCharges}</RoamingListItem>
            <RoamingListItem>
              <a
                href={content.priceGuideLink}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={content.priceGuideAriaLabel}
              >
                {content.priceGuideLinkText}
              </a>
            </RoamingListItem>
          </ul>
          <AltPara>{content.callingAbroadPrompt(display_country)}</AltPara>
          <a
            href={content.priceGuideLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={content.priceGuideAriaLabel}
          >
            {content.seeAllPrices}
          </a>
          {isIreland && <AltPara>{content.irelandFootnote}</AltPara>}
        </div>
        <Card>
          <h2 className={classes.cardHeadingYellow}>{content.cardHeading}</h2>
          <h2>{content.cardSubheading}</h2>
          <AltPara>{content.cardBody}</AltPara>
          <a href={content.setupLinkPath} className={classes.setupLink}>
            {content.setupLinkText}
          </a>
        </Card>
      </Container>
    </SiteContainer>
  )
}

export default withApp(Europe)

export const Head: FC<EuropeProps> = ({ pageContext, location }) => (
  <PageHead
    title={content.pageTitle(pageContext.display_country)}
    location={location}
  />
)
